/* eslint-disable react/forbid-elements */
import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';

export interface IStatusLabelProps {
    value?: string | undefined;
}

export function SurveyTaskProgressStatusLabel(props: IStatusLabelProps) {
    const translate = useTranslate();

    if (!props.value) {
        return null;
    }
    const text = translate(`surveyTaskProgressStatus.${props.value}`);
    return (
        <span className={`label survey-task-progress-label-${props.value}`} title={text}>
            {text}
        </span>
    );
}
